module.exports = __webpack_public_path__ + "img/cancelSuccess.58dacb09.png";